export function stopAllElements(els: Record<string, HTMLAudioElement | null>) {
  try {
    for (const k of Object.keys(els || {})) {
      const el = els[k];
      if (!el) continue;
      try { (el as any).onended = null; } catch {}
      try { el.pause(); } catch {}
      try { el.removeAttribute('src'); el.load(); } catch {}
      try { el.muted = true; el.volume = 0; } catch {}
    }
  } catch {}
}

export default stopAllElements;
